import React from 'react';
import './style.css';

const FloatingWhatsApp = () => {
    return (
        <a
            href="https://wa.me/5511969112237?text=Olá, gostaria de mais informações"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-whatsapp-container"
            title="Entre em contato pelo WhatsApp"
        >
            <div className="whatsapp-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="100" height="100" fill="white">
                    <path d="M16 .396C7.164.396 0 7.56 0 16.396c0 2.884.754 5.59 2.07 7.93L0 32l7.91-2.062a15.94 15.94 0 0 0 8.09 2.062c8.836 0 16-7.164 16-16S24.836.396 16 .396zm0 29.09a13.01 13.01 0 0 1-6.64-1.82l-.476-.283-4.7 1.225 1.253-4.584-.31-.472A12.97 12.97 0 0 1 3 16.396c0-7.18 5.82-13 13-13s13 5.82 13 13-5.82 13-13 13zm7.19-9.69c-.39-.196-2.3-1.136-2.656-1.266-.356-.13-.616-.196-.876.196-.26.39-1.006 1.266-1.233 1.526-.226.26-.453.293-.842.098-.39-.196-1.645-.606-3.134-1.93-1.158-1.033-1.94-2.31-2.166-2.7-.226-.39-.024-.6.17-.795.174-.173.39-.453.583-.68.196-.226.26-.39.39-.65.13-.26.065-.488-.032-.683-.098-.196-.876-2.113-1.2-2.893-.316-.758-.636-.655-.876-.667l-.746-.014c-.26 0-.683.098-1.04.488-.356.39-1.363 1.33-1.363 3.24 0 1.91 1.396 3.75 1.59 4.01.196.26 2.75 4.2 6.67 5.89.933.402 1.66.642 2.227.822.935.297 1.786.255 2.458.155.75-.112 2.3-.94 2.626-1.85.325-.91.325-1.69.227-1.85-.098-.163-.356-.26-.746-.456z" />
                </svg>
            </div>
            <span className="whatsapp-text">CONTATE NO WHATSAPP</span>
        </a>
    );
};

export default FloatingWhatsApp;
